import { LEAD_TRACKING_STORAGE_KEY } from '../constants';
import transformUnqualifiedItems from './transform-unqualified-items';

const getLeadTracking = (source = 'site') => {
  const olistLeadStorage = JSON.parse(localStorage.getItem(LEAD_TRACKING_STORAGE_KEY));
  const defaultLead = {
    signup_url: window.location.href,
    pre_signup_url: document.referrer,
    source,
  };

  const lead = olistLeadStorage
    ? {
        ...olistLeadStorage.lead,
        ...defaultLead,
      }
    : defaultLead;

  return lead;
};

export { transformUnqualifiedItems, getLeadTracking };
